import React, { Component } from "react";
import {
  Table,
  Pagination,
  Col,
  Row,
  Button,
  Select,
  Input,
  Dropdown,
  Menu,
  Form,
  Checkbox
} from "antd";
import moment from "moment";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
import AddEditHospitalModal from "./AddEditHospitalModal";
const FormItem = Form.Item;
const { Option } = Select;
const { Search } = Input;
const searchOptions = {
  componentRestrictions: { country: "in" }
};

export default class ClinicListView extends Component {
  render() {
    const {
      clinicList,
      allRecords,
      allPages,
      pageNo,
      onPageChange,
      searchText,
      handleSearchText,
      handleSearch,
      stateName,
      handleStateChange,
      handleStateSearch,
      navigateToClinicDetails,
      bankDetailsFilter,
      handleBankDetailsFilter,
      specModules,
      selectedSpecModuleFilter,
      handleSelectSpecModuleClinic,
      handleUpdateClinicModule,
      activateModule,
      handleActivationConfirmation,
      selectedClinicId,
      handleMenuClick,
      toggleHospitalModal,
      showHospitalModal,
      fetchClinicData,
      onHospitalCheckboxChange,
      selectedFeatureFlag
    } = this.props;

    const columns = [
      {
        title: "Clinic Name",
        align: "left",
        render: record => (
          <Link to={`/clinics-details/${record.id}/basic-details`}>
            {record.name || "--"}
          </Link>
        )
      },
      {
        title: "email",
        align: "left",
        render: record => <div>{record.email || "--"}</div>
      },
      {
        title: "phone number",
        align: "left",
        render: record => <div>{record.phone_number || "--"}</div>
      },
      {
        title: "town/city",
        align: "left",
        render: record => (
          <div>
            {(record && record.location && record.location.city) || "--"}
          </div>
        )
      },
      {
        title: "state",
        align: "left",
        render: record => (
          <div>
            {(record && record.location && record.location.state) || "--"}
          </div>
        )
      },
      {
        title: "Activated module",
        align: "left",
        render: record => (
          <div>
            {record?.clinic_spec_modules &&
              record?.clinic_spec_modules?.length > 0 &&
              record?.clinic_spec_modules
                .map(obj => {
                  return obj.name;
                })
                .join(", ")}

            {/* {record?.clinic_spec_modules &&
              record?.clinic_spec_modules?.length === 0 && !record?.ipd_enabled &&
              "--"} */}

            {record?.ipd_enabled ? " IPD" : ""}
            {record?.care_package_enabled ? " Care Packages" : ""}
            {record?.surgery_enabled ? " Surgeries" : ""}
            {record?.abdm_enabled ? " ABDM" : ""}
          </div>
        )
      },
      {
        title: "Select Module",
        align: "left",
        width: 200,
        render: record => (
          <div className="d-flex vertical-align-center">
            <Select
              style={{ width: 120 }}
              onChange={(val, obj, recordId) =>
                handleUpdateClinicModule(val, obj, record)
              }
              placeholder="Select"
            >
              {specModules.length > 0 &&
                specModules.map(obj => {
                  return (
                    <Option key={obj?.id} value={obj?.id} specObj={obj}>
                      {obj?.name}
                    </Option>
                  );
                })}
            </Select>
            <Button
              type="primary"
              onClick={() => handleActivationConfirmation(record)}
              className="ml-5"
            >
              {activateModule &&
              activateModule != undefined &&
              selectedClinicId === record.id
                ? "Deactivate"
                : "Activate"}{" "}
            </Button>
          </div>
        )
      }
    ];
    const menu = (
      <Menu onClick={handleMenuClick}>
        <Menu.Item key={"hospital"}>Hospital</Menu.Item>
      </Menu>
    );
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row>
            <Col span={5} className="heading-domain">
              Clinics
            </Col>
          </Row>
          <Row type="flex" align="middle" gutter={16}>
            <Col span={5}>
              <label>{strings.dashboard.searchBy}</label>
              <Search
                className="mt-7"
                value={searchText}
                onChange={handleSearchText}
                placeholder={strings.dashboard.searchByClinicPlaceholder}
                onSearch={handleSearch}
                onPressEnter={handleSearch}
                allowClear
              />
            </Col>
            <Col span={5}>
              <label>{strings.dashboard.searchBy}</label>
              <Search
                className="mt-7"
                value={stateName}
                onChange={handleStateChange}
                placeholder={strings.dashboard.searchByStatePlaceholder}
                onSearch={handleStateSearch}
                onPressEnter={handleStateSearch}
                allowClear
              />
            </Col>
            <Col span={4}>
              <label>{"Spec module:"}</label>
              <Select
                className="mt-7 full-width"
                value={
                  selectedFeatureFlag
                    ? selectedFeatureFlag
                    : selectedSpecModuleFilter
                }
                onSelect={handleSelectSpecModuleClinic}
              >
                <Option key="all" value={"all"}>
                  All
                </Option>
                {specModules.length > 0 &&
                  specModules.map(obj => {
                    return (
                      <Option key={obj?.id} value={obj?.id} specObj={obj}>
                        {obj?.name}
                      </Option>
                    );
                  })}
              </Select>
            </Col>
            <Col span={3}>
              <label>{"Bank details:"}</label>
              <Select
                className="mt-7 full-width"
                value={bankDetailsFilter}
                onChange={handleBankDetailsFilter}
              >
                <Option key="1" value={null}>
                  All
                </Option>
                <Option key="2" value={"true"}>
                  Added{" "}
                </Option>
                <Option key="3" value={"false"}>
                  Not Added{" "}
                </Option>
              </Select>
            </Col>
            <Col span={3} className="mt-20">
              <Checkbox onChange={onHospitalCheckboxChange}>
                Is hospital
              </Checkbox>
            </Col>
            <Col className="mt-25">
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button size="small" type="primary">
                  Add
                </Button>
              </Dropdown>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={clinicList}
              pagination={false}
              rowKey="id"
              // onRow={(record, rowIndex) => {
              //   return {
              //     onClick: event => {
              //       navigateToClinicDetails(event, record.id);
              //     } // click row
              //   };
              // }}
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {allRecords > 10 && (
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {allRecords > 10 && (
            <Pagination
              total={allRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={10}
              defaultCurrent={pageNo}
            />
          )}
          {showHospitalModal && (
            <AddEditHospitalModal
              showModal={showHospitalModal}
              toggleModal={toggleHospitalModal}
              fetchClinicData={fetchClinicData}
            />
          )}
        </div>
      </div>
    );
  }
}
